<template>
  <VLayout :title="$t('doctor_list.title')">
    <b-table
      id="retail-order-table-list"
      class="align-middle"
      responsive
      outlined
      bordered
      stacked="sm"
      :busy.sync="isBusy"
      :items="tableProvider"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
    >

      <template v-slot:cell(actions)="data" v-if="show_action_column">
        <b-button
          size="sm"
          variant="primary-b"
          @click="routeToUpdate(data.item)"
        >{{ $t('doctor_list.update_information') }}</b-button>
      </template>
    </b-table>
    <b-row class="mt-4" v-if="doctors">
      <b-col cols="12" md="3">
        <b-button @click="routeToNewDoctor()" variant="primary" size="xl">{{ $t('doctor_list.new_doctor') }}</b-button>
      </b-col>
    </b-row>

    <div class="mb-4" v-if="!doctors">
      <router-link :to="{name: 'doctordata'}">{{ $t('doctor_list.new_question_doctor') }}</router-link>
    </div>

  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";

export default {
  components: {
    VLayout,
  },
  props: {
    show_action_column: {
      type: Boolean,
      default: true,
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        doctor_list: {
          title: "Doctor Information",
          new_doctor: "Create other Medical account",
          new_question_doctor: "Are you a doctor? Create your Medical account",
          update_information: "Update information",
          headtable_firstname: "Name",
          headtable_lastname: "Last name",
          headtable_professional_number: "Professional number",
          headtable_specialty: "Specialty",
          headtable_actions: "Actions",
        },
      },
    },
  },
  data() {
    return {
      search_term: "",
      isBusy: false,
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      loading: true,
      doctors: undefined,
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "firstname",
          label: this.$t("doctor_list.headtable_firstname"),
          class: "selectable",
          thClass: "unselectable",
        },
        {
          key: "lastname",
          label: this.$t("doctor_list.headtable_lastname"),
          class: "selectable",
          thClass: "unselectable",
        },
        {
          key: "professional_number",
          label: this.$t("doctor_list.headtable_professional_number"),
          class: "selectable",
          thClass: "unselectable",
        },
        {
          key: "specialty",
          label: this.$t("doctor_list.headtable_specialty"),
          class: "selectable",
          thClass: "unselectable",
        },
        {
          key: "actions",
          label: this.$t("doctor_list.headtable_actions"),
          thClass: this.show_action_column ? "" : "d-none",
          tdClass: this.show_action_column ? "" : "d-none",
        },
      ];
    },
  },
  methods: {
    routeToNewDoctor() {
      this.$router.replace({
        name: "doctordata",
      });
    },
    routeToUpdate(doctor) {
      this.$router.replace({
        name: "doctordata",
        params: {
          doctor_uuid: doctor.uuid,
        },
      });
    },
    tableProvider() {
      return this.$store
        .dispatch("naturalperson/REQUEST_DOCTOR", {
          per_page: this.perPage,
          current_page: this.currentPage,
        })
        .then(
          response => {
            const items = response.data.results;
            this.loading = false;
            this.totalRows = response.data.count;
            this.doctors = items;
            return items;
          },
          err => {
            this.$sentry({ capture: err });
            this.mnotify_error({
              text: this.$t("doctor_list.error.cannot_load_refunds"),
            });
            this.loading = false;
            return undefined;
          }
        );
    },
  },
};
</script>

